import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { GateWayService } from '../../services/gateway-service.service';
import { async } from '@angular/core/testing';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  public errorCode: any;
  public state: any;
  constructor(
    private router: Router,
    private gwService: GateWayService,
    private route: ActivatedRoute,
  ) {
    this.errorCode = this.route.snapshot.queryParams["errorCode"];
    this.state = this.route.snapshot.queryParams["state"];
  }

  ngOnInit() {
    console.log(" this.errorCode : ", this.errorCode)
    console.log(" this.state : ", this.state)
    this.checkError();
  }
  async checkError() {
    switch (this.errorCode) {
      case '00':
        Swal.fire({
          icon: 'error',
          title: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
          text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
          showConfirmButton: true,
        }).then(async (result) => {
          await this.gwService.getADMDLoginURI(this.state).subscribe(success => {
            console.log("success :", success)
            if(success.code == 200) window.location.href = success.data.url
          });
        })
        break;
      case '01':
        Swal.fire({
          icon: 'error',
          title: 'ยังไม่ได้รับสิทธิ์การใช้งาน',
          text: 'กรุณาติดต่อแอดมินเพื่อเข้าใช้งาน',
          showConfirmButton: true,
        }).then(async (result) => {
          await this.gwService.getADMDLoginURI(this.state).subscribe(success => {
            console.log("success :", success)
            if(success.code == 200) window.location.href = success.data.url
          });
        })
        break;
      case '02':
        Swal.fire({
          icon: 'error',
          title: 'ไม่ได้รับอนุญาตให้ใช้งาน',
          text: 'ไม่ได้รับอนุญาตให้ใช้งาน',
          showConfirmButton: true,
        }).then(async (result) => {
          await this.gwService.getADMDLoginURI(this.state).subscribe(success => {
            console.log("success :", success)
            if(success.code == 200) window.location.href = success.data.url
          });
        })
        break;
        case '03':
        Swal.fire({
          icon: 'error',
          title: 'ไม่พบฟาร์มที่ท่านสามารถเข้าใช้งานได้',
          text: 'กรุณาติดต่อแอดมินเพื่อเข้าใช้งาน',
          showConfirmButton: true,
        }).then(async (result) => {
          await this.gwService.clearPlatformToken().subscribe(success => {
            console.log("success :", success)
            if(success.code == 200) this.router.navigate(["/homepage"]); //// redirect to honepage
          });

          
        })
        break;
      default: break;
    }
  }
}
